import { render } from "./PrintPrescription.vue?vue&type=template&id=cf069618"
import script from "./PrintPrescription.vue?vue&type=script&lang=js"
export * from "./PrintPrescription.vue?vue&type=script&lang=js"

import "./PrintPrescription.vue?vue&type=style&index=0&id=cf069618&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__